<template>
  <div class="live-report-area">
    <div class="report-loader text-center mb-5" v-if="loading">
      <img src="/images/loading.gif" />
    </div>
    <div class="text-center" v-else-if="error">
      Sorry there has been an error. Please Contact ITR Support
    </div>
    <div v-else>
      <template v-if="consulting_slug === 'aatk'">
        <AATKComponent
          ref="live_report_child"
          :slug="page_slug"
          :index="index"
          :preview="preview"
          :consulting_slug="consulting_slug"
          :apiResponse="apiResponse"
          :reportID="ondemand_report_id"
          :reportTypeId="reportTypeId"
          @updateSlug="updateSlug"
        />
      </template>

      <template
        v-else-if="consulting_slug === 'evp-series' && report360 === '1'"
      >
        <EVPFlex360Component
          ref="live_report_child"
          :reportTypeId="reportTypeId"
          :slug="page_slug"
          :index="index"
          :preview="preview"
          :report360="report360"
          :consulting_slug="consulting_slug"
          :apiResponse="apiResponse"
          :reportInfo="reportInfo"
          :outlook="outlook"
          :indicator_signals="indicator_signals"
          :forecast="forecast"
          :data_trends="data_trends"
          :roc="roc"
          :indicators="indicators"
          :divisions="roc_division"
          :forecast_history="forecast_history"
          :definitions="definitions"
          :cover_page="cover_page"
          :forecast_market_index="forecast_market_index"
          :forecast_history_market_index="forecast_history_market_index"
          :roc_market_index="roc_market_index"
          :reportID="ondemand_report_id"
          @updateSlug="updateSlug"
          @getOutlookPage="getOutlookPage"
          @getIndicatorSignalsPage="getIndicatorSignalsPage"
          @getIndicatorDefinitionsPage="getIndicatorDefinitionsPage"
          @getForecastPage="getForecastPage"
          @getDataTrendsPage="getDataTrendsPage"
          @getROCPage="getROCPage"
          @getForecastHistoryPage="getForecastHistoryPage"
          @getIndicator="getIndicator"
          @getCoverPage="getCoverPage"
          @getROCDivision="getROCDivision"
          @getMarketIndexForecastPage="getMarketIndexForecastPage"
          @getMarketIndexForecastHistoryPage="getMarketIndexForecastHistoryPage"
          @getRoCMarketIndexPage="getRoCMarketIndexPage"
        />
      </template>
      <template
        v-else-if="consulting_slug === 'evp-series' && reportAddOns === '1'"
      >
        <EVPFlexAddOnComponent
          ref="live_report_child"
          :slug="page_slug"
          :index="index"
          :preview="preview"
          :reportAddOns="reportAddOns"
          :consulting_slug="consulting_slug"
          :apiResponse="apiResponse"
          :reportID="ondemand_report_id"
          :reportTypeId="reportTypeId"
          @updateSlug="updateSlug"
        />
      </template>
      <template
        v-else-if="
          consulting_slug === 'evp-series' &&
          reportAddOns !== '1' &&
          report360 !== '1'
        "
      >
        <!-- pass in each individual page object and function to fetch -->
        <EVPFlexComponent
          ref="live_report_child"
          :slug="page_slug"
          :index="index"
          :preview="preview"
          :consulting_slug="consulting_slug"
          :reportInfo="reportInfo"
          :outlook="outlook"
          :indicator_signals="indicator_signals"
          :forecast="forecast"
          :data_trends="data_trends"
          :roc="roc"
          :indicators="indicators"
          :divisions="roc_division"
          :forecast_history="forecast_history"
          :definitions="definitions"
          :cover_page="cover_page"
          :reportID="ondemand_report_id"
          :reportTypeId="reportTypeId"
          @updateSlug="updateSlug"
          @getOutlookPage="getOutlookPage"
          @getIndicatorSignalsPage="getIndicatorSignalsPage"
          @getIndicatorDefinitionsPage="getIndicatorDefinitionsPage"
          @getForecastPage="getForecastPage"
          @getDataTrendsPage="getDataTrendsPage"
          @getROCPage="getROCPage"
          @getForecastHistoryPage="getForecastHistoryPage"
          @getIndicator="getIndicator"
          @getCoverPage="getCoverPage"
          @getROCDivision="getROCDivision"
        />
      </template>
      <template v-else-if="consulting_slug === 'timing-model'">
        <TimingModelComponent
          ref="live_report_child"
          :slug="page_slug"
          :index="index"
          :preview="preview"
          :consulting_slug="consulting_slug"
          :apiResponse="apiResponse"
          :reportID="ondemand_report_id"
          :reportTypeId="reportTypeId"
          @updateSlug="updateSlug"
        />
      </template>
      <template
        v-else-if="
          consulting_slug === 'forecast-chart' ||
          consulting_slug === 'company-forecast'
        "
      >
        <ForecastChartsComponent
          ref="live_report_child"
          :slug="page_slug"
          :index="index"
          :preview="preview"
          :consulting_slug="consulting_slug"
          :apiResponse="apiResponse"
          :reportID="ondemand_report_id"
          :reportTypeId="reportTypeId"
          @updateSlug="updateSlug"
        />
      </template>
      <template v-else-if="consulting_slug === 'market-forecast'">
        <MarketForecastComponent
          ref="live_report_child"
          :slug="page_slug"
          :index="index"
          :preview="preview"
          :consulting_slug="consulting_slug"
          :apiResponse="apiResponse"
          :reportID="ondemand_report_id"
          :reportTypeId="reportTypeId"
          @updateSlug="updateSlug"
        />
      </template>
      <template v-else-if="consulting_slug === 'market-index'">
        <MarketIndexComponent
          ref="live_report_child"
          :slug="page_slug"
          :index="index"
          :preview="preview"
          :consulting_slug="consulting_slug"
          :apiResponse="apiResponse"
          :reportID="ondemand_report_id"
          :reportTypeId="reportTypeId"
          @updateSlug="updateSlug"
        />
      </template>
      <template v-else-if="consulting_slug === 'dashboard'">
        <DashboardComponent
          ref="live_report_child"
          :apiID="report_id"
          :reportID="ondemand_report_id"
          :slug="page_slug"
          :index="index"
          :preview="preview"
          :consulting_slug="consulting_slug"
          :apiResponse="apiResponse"
          :reportTypeId="reportTypeId"
          @updateSlug="updateSlug"
        />
      </template>
    </div>
    <img
      id="itrLogo"
      src="/images/logos/new/itr-corporate-logo-color-no-white-space.png"
      class="hide"
    />
    <img
      id="forecastRevisedBar"
      src="/images/forecastRevisedImage.png"
      class="hide"
    />
    <img
      id="dataTrendsBar"
      src="/images/dataTrendsAdjustedImage.png"
      class="hide"
    />
    <img
      id="ratesOfChangeBar"
      src="/images/ratesOfChangeAdjustedImage.png"
      class="hide"
    />
    <img
      id="pptCoverBackground"
      src="/images/ppt-cover-page-background.png"
      class="hide"
    />
    <img id="pptFooter" src="/images/pptFooter.png" class="hide" />
    <img
      id="pptLeadingIndicatorsBackground"
      src="/images/leading-indicators-bkgnd.png"
      class="hide"
    />
    <img
      id="pptBusinessBackground"
      src="/images/your-business-bkgnd.png"
      class="hide"
    />
    <img id="targetBusiness" src="/images/TargetBusiness.png" class="hide" />
    <span id="tradeMark" class="hide">&#8482;</span>
    <span id="copyright" class="hide">&#169;</span>
    <div id="coverPageChart" class="hide"></div>
  </div>
</template>

<script>
  import axios from 'axios';
  import TimingModelComponent from '~/components/report/modules/live-report/timingModel/TimingModelComponent.vue';
  import EVPFlexComponent from '~/components/report/modules/live-report/evpflex/EVPFlexComponent.vue';
  import EVPFlexAddOnComponent from '~/components/report/modules/live-report/evpflex/EVPFlexAddOnComponent.vue';
  import EVPFlex360Component from '~/components/report/modules/live-report/evpflex/EVPFlex360Component.vue';
  import ForecastChartsComponent from '~/components/report/modules/live-report/forecastCharts/ForecastChartsComponent.vue';
  import AATKComponent from '~/components/report/modules/live-report/aatk/AATKComponent.vue';
  import MarketForecastComponent from '~/components/report/modules/live-report/market-forecast/MarketForecastComponent.vue';
  import MarketIndexComponent from '~/components/report/modules/live-report/market-index/MarketIndexComponent.vue';
  import DashboardComponent from '~/components/report/modules/live-report/dashboard/DashboardComponent.vue';

  export default {
    name: 'LiveReportParentComponent',
    props: {
      live_id: {
        type: [Number, String],
        required: true,
      },
      report_id: {
        type: [Number, String],
        default: 0,
      },
      ondemand_report_id: {
        type: [Number, String],
        default: 0,
      },
      consulting_slug: {
        type: String,
        default: '',
      },
      preview: {
        type: [Boolean, String],
        default: false,
      },
      reportAddOns: {
        type: [Boolean, String],
        default: false
      },
      report360: {
        type: [Boolean, String],
        default: false,
      },
      reportTypeId: {
        type: [Number, String],
        default: 0,
      },
    },
    components: {
      TimingModelComponent,
      EVPFlexComponent,
      EVPFlexAddOnComponent,
      EVPFlex360Component,
      ForecastChartsComponent,
      AATKComponent,
      MarketForecastComponent,
      MarketIndexComponent,
      DashboardComponent,
    },
    data: () => ({
      loading: true,
      error: false,
      endpoint: '',
      apiResponse: {},
      reportInfo: {},
      page_slug: '',
      index: 0,
      outlook: null,
      indicator_signals: null,
      forecast: null,
      data_trends: null,
      roc: null,
      indicators: [],
      roc_division: [],
      forecast_history: null,
      definitions: null,
      cover_page: null,
      cancelToken: null,
      forecast_market_index: null,
      forecast_history_market_index: null,
      roc_market_index: null,
    }),
    computed: {
      simplifiedPageSlug() {
        return this.page_slug.replace(/\d+$/, '');
      },
      selectedDivision() {
        if (this.simplifiedPageSlug === 'division') {
          const index = this.getIndexFromPageSlug();
          return this.roc_division[index];
        }

        return null;
      },
      selectedIndicator() {
        if (this.simplifiedPageSlug === 'indicator') {
          const index = this.getIndexFromPageSlug();
          return this.indicators[index];
        }

        return null;
      },
    },
    watch: {
      report_id: {
        deep: true,
        // immediate: true,
        handler(newVal, oldVal) {
          // cancel any open requests from previous report
          this.cancelToken.cancel();

          // init new cancel token for new selected report_id
          this.cancelToken = axios.CancelToken.source();

          this.error = false;
          this.loading = true;
          this.endpoint = '';

          //reset data values
          this.index = 0;
          this.endpoint = '';
          this.page_slug = '';

          // clear each page back to default
          this.reportInfo = null;
          this.outlook = null;
          this.indicator_signals = null;
          this.forecast = null;
          this.data_trends = null;
          this.roc = null;
          this.indicators = [];
          this.roc_division = [];
          this.forecast_history = null;
          this.definitions = null;
          this.cover_page = null;
          this.forecast_market_index = null;
          this.forecast_history_market_index = null;
          this.roc_market_index = null;

          //get new report data
          this.setEndpoint();
        },
      },
    },
    mounted() {
      // set cancelToken on first load
      this.cancelToken = axios.CancelToken.source();

      this.setEndpoint();
    },
    methods: {
      getIndexFromPageSlug() {
        return this.page_slug.replace(/\D/g, '');
      },
      // currently used for EVP Flex
      // new function to request high level report info from ITR API
      async getReportInfo() {
        if (this.live_id == this.report_id) {
          this.endpoint = '/consulting/evp-series/report/0/' + this.live_id;
        } else {
          this.endpoint =
            '/consulting/evp-series/report/' + this.report_id + '/0';
        }

        try {
          const { data } = await axios.get(this.endpoint, {
            cancelToken: this.cancelToken.token,
          });

          if (data.success) {
            // set report info response
            this.reportInfo = data.data;

            // set blank indicator models so render components before actually requesting data
            for (
              let i = 0;
              i < this.reportInfo.IndicatorIndexList.length;
              i++
            ) {
              this.indicators.push(null);
            }

            // set blank indicator models so render components before actually requesting data
            for (let i = 0; i < this.reportInfo.DivisionIndexList.length; i++) {
              this.roc_division.push(null);
            }
          } else {
            this.error = true;
            document.getElementById('report-page').innerHTML = '';
            if (!this.preview)
              document.getElementById('paginationPagesLabel').innerHTML = '';
          }

          this.loading = false;
        } catch (error) {
          this.error = true;
          document.getElementById('report-page').innerHTML = '';
          if (!this.preview)
            document.getElementById('paginationPagesLabel').innerHTML = '';
          this.loading = false;
          this.$emit('toggleDisabledBit');
        }
      },
      setEndpoint() {
        if (this.consulting_slug === 'timing-model') {
          if (this.live_id == this.report_id) {
            this.endpoint = '/consulting/timing-model/0/' + this.live_id;
          } else {
            this.endpoint = '/consulting/timing-model/' + this.report_id + '/0';
          }
        } else if (
          this.consulting_slug === 'evp-series' &&
          this.reportAddOns === '1' &&
          this.report360 !== '1'
        ) {
          if (this.live_id == this.report_id) {
            this.endpoint = '/consulting/evp-addon-series/0/' + this.live_id;
          } else {
            this.endpoint =
              '/consulting/evp-addon-series/' + this.report_id + '/0';
          }
        } else if (
          this.consulting_slug === 'evp-series' &&
          this.report360 === '1' &&
          this.reportAddOns !== '1'
        ) {
          if (this.live_id == this.report_id) {
            this.endpoint = '/consulting/evp-360-series/0/' + this.live_id;
          } else {
            this.endpoint =
              '/consulting/evp-360-series/' + this.report_id + '/0';
          }
        } else if (
          this.consulting_slug === 'evp-series' &&
          this.reportAddOns !== '1' &&
          this.report360 !== '1'
        ) {
          if (this.live_id == this.report_id) {
            this.endpoint = '/consulting/evp-series/0/' + this.live_id;
          } else {
            this.endpoint = '/consulting/evp-series/' + this.report_id + '/0';
          }
        } else if (this.consulting_slug === 'aatk') {
          if (this.live_id == this.report_id) {
            this.endpoint = '/consulting/aatk/0/' + this.live_id;
          } else {
            this.endpoint = '/consulting/aatk/' + this.report_id + '/0';
          }
        } else if (
          this.consulting_slug === 'forecast-chart' ||
          this.consulting_slug === 'company-forecast'
        ) {
          if (this.live_id == this.report_id) {
            this.endpoint = '/consulting/evp-forecast-charts/0/' + this.live_id;
          } else {
            this.endpoint =
              '/consulting/evp-forecast-charts/' + this.report_id + '/0';
          }
        } else if (this.consulting_slug === 'market-forecast') {
          if (this.live_id == this.report_id) {
            this.endpoint = '/consulting/market-forecast/0/' + this.live_id;
          } else {
            this.endpoint =
              '/consulting/market-forecast/' + this.report_id + '/0';
          }
        } else if (this.consulting_slug === 'market-index') {
          if (this.live_id == this.report_id) {
            this.endpoint = '/consulting/market-index/0/' + this.live_id;
          } else {
            this.endpoint = '/consulting/market-index/' + this.report_id + '/0';
          }
        } else if (this.consulting_slug === 'dashboard') {
          if (this.live_id == this.report_id) {
            this.endpoint = '/consulting/dashboard/0/' + this.live_id;
          } else {
            this.endpoint = '/consulting/dashboard/' + this.report_id + '/0';
          }
        }

        // ccb320D - redirect path for EVP Flex - otherwise do default
        if (
          this.consulting_slug === 'evp-series' &&
          this.reportAddOns !== '1'
        ) {
          this.getReportInfo();
        } else if (this.endpoint !== '') {
          this.getApidata();
        } else {
          this.loading = false;
          // this.test = true;
          this.error = true;
        }
      },
      getApidata() {
        axios
          .post(this.endpoint, { cancelToken: this.cancelToken.token })
          .then((success) => {
            if (success.data.success) {
              this.setSlug(success.data.data);
              this.reportInfo = success.data.data;
            } else {
              this.error = true;
              document.getElementById('report-page').innerHTML = '';
              if (!this.preview)
                document.getElementById('paginationPagesLabel').innerHTML = '';
              this.loading = false;

              this.$emit('toggleDisabledBit');
            }
          })
          //returns success message when loading reports
          //in the .then we don't know if data is returned properly
          .catch((error) => {
            this.error = true;
            document.getElementById('report-page').innerHTML = '';
            if (!this.preview)
              document.getElementById('paginationPagesLabel').innerHTML = '';
            this.loading = false;
            this.$emit('toggleDisabledBit');
          });
      },
      setSlug(apiData) {
        if (this.consulting_slug === 'timing-model') {
          this.updateSlug('indicator-signals');
        } else if (
          this.consulting_slug === 'evp-series' &&
          this.reportAddOns === '1'
        ) {
          let tempSlug = this.determineSlugAddon(apiData);
          this.updateSlug(tempSlug);
        } else if (
          this.consulting_slug === 'evp-series' &&
          this.report360 === '1'
        ) {
          this.updateSlug('outlook');
        } else if (this.consulting_slug === 'aatk') {
          this.updateSlug('forecast');
        } else if (
          this.consulting_slug === 'forecast-chart' ||
          this.consulting_slug === 'company-forecast'
        ) {
          this.updateSlug('forecast');
        } else if (this.consulting_slug === 'evp-series') {
          this.updateSlug('outlook');
        } else if (this.consulting_slug === 'market-forecast') {
          this.updateSlug('forecast');
        } else if (this.consulting_slug === 'market-index') {
          this.updateSlug('forecast');
        } else if (this.consulting_slug === 'dashboard') {
          this.updateSlug('dashboard');
        }

        this.apiResponse = apiData;

        this.loading = false;
        this.$emit('toggleDisabledBit');
      },
      determineSlugAddon(apiData) {
        if (apiData.PageOrder?.length > 0) {
          return apiData.PageOrder[0].Value;
        } else {
          this.loading = false;
          this.error = true;
          return '';
        }
      },
      updateSlug(slug, index) {
        this.page_slug = slug;
        this.index = index;
      },
      downloadPDF() {
        this.$refs.live_report_child.downloadPDF();
      },
      downloadPPT() {
        this.$refs.live_report_child.downloadPPT();
      },
      async getOutlookPage() {
        var url = '/consulting/evp-series/outlook/' + this.report_id + '/0';
        if (this.live_id == this.report_id) {
          url = '/consulting/evp-series/outlook/0/' + this.live_id;
        }

        try {
          const { data } = await axios.get(url, {
            cancelToken: this.cancelToken.token,
          });

          if (data.success) {
            this.outlook = data.data;
          }
        } catch (error) {
          // TODO: HANDLE ERROR - This is just silencing the error
        }

        this.$emit('toggleDisabledBit');
      },
      async getIndicatorSignalsPage() {
        var url =
          '/consulting/evp-series/indicator-signals/' + this.report_id + '/0';
        if (this.live_id == this.report_id) {
          url = '/consulting/evp-series/indicator-signals/0/' + this.live_id;
        }

        try {
          const { data } = await axios.get(url, {
            cancelToken: this.cancelToken.token,
          });

          if (data.success) {
            this.indicator_signals = data.data;
          }
        } catch (error) {
          // TODO: HANDLE ERROR - This is just silencing the error
        }
      },
      async getForecastPage() {
        var url = '/consulting/evp-series/forecast/' + this.report_id + '/0';
        if (this.live_id == this.report_id) {
          url = '/consulting/evp-series/forecast/0/' + this.live_id;
        }

        try {
          const { data } = await axios.get(url, {
            cancelToken: this.cancelToken.token,
          });

          if (data.success) {
            this.forecast = data.data;
          }
        } catch (error) {
          // TODO: HANDLE ERROR - This is just silencing the error
        }
      },
      async getDataTrendsPage() {
        var url = '/consulting/evp-series/data-trends/' + this.report_id + '/0';
        if (this.live_id == this.report_id) {
          url = '/consulting/evp-series/data-trends/0/' + this.live_id;
        }

        try {
          const { data } = await axios.get(url, {
            cancelToken: this.cancelToken.token,
          });

          if (data.success) {
            this.data_trends = data.data;
          }
        } catch (error) {
          // TODO: HANDLE ERROR - This is just silencing the error
        }
      },
      async getROCPage() {
        var url = '/consulting/evp-series/roc/' + this.report_id + '/0';
        if (this.live_id == this.report_id) {
          url = '/consulting/evp-series/roc/0/' + this.live_id;
        }

        try {
          const { data } = await axios.get(url, {
            cancelToken: this.cancelToken.token,
          });

          if (data.success) {
            this.roc = data.data;
          }
        } catch (error) {
          // TODO: HANDLE ERROR - This is just silencing the error
        }
      },
      async getIndicator(index = -1) {
        if (index === -1) return;

        var url =
          '/consulting/evp-series/indicator/' + this.report_id + '/0/' + index;
        if (this.live_id == this.report_id) {
          url =
            '/consulting/evp-series/indicator/0/' + this.live_id + '/' + index;
        }

        try {
          const { data } = await axios.get(url, {
            cancelToken: this.cancelToken.token,
          });

          if (data.success) {
            this.indicators[index] = data.data;
          }
        } catch (error) {
          // TODO: HANDLE ERROR - This is just silencing the error
        }
      },
      async getROCDivision(index = -1) {
        if (index === -1) return;

        var url =
          '/consulting/evp-series/roc-division/' +
          this.report_id +
          '/0/' +
          index;
        if (this.live_id == this.report_id) {
          url =
            '/consulting/evp-series/roc-division/0/' +
            this.live_id +
            '/' +
            index;
        }

        try {
          const { data } = await axios.get(url, {
            cancelToken: this.cancelToken.token,
          });

          if (data.success) {
            this.roc_division[index] = data.data;
          }
        } catch (error) {
          // TODO: HANDLE ERROR - This is just silencing the error
        }
      },
      async getForecastHistoryPage() {
        var url =
          '/consulting/evp-series/forecast-history/' + this.report_id + '/0';
        if (this.live_id == this.report_id) {
          url = '/consulting/evp-series/forecast-history/0/' + this.live_id;
        }

        try {
          const { data } = await axios.get(url, {
            cancelToken: this.cancelToken.token,
          });

          if (data.success) {
            this.forecast_history = data.data;
          }
        } catch (error) {
          // TODO: HANDLE ERROR - This is just silencing the error
        }
      },
      async getIndicatorDefinitionsPage() {
        var url =
          '/consulting/evp-series/indicator-definitions/' +
          this.report_id +
          '/0';
        if (this.live_id == this.report_id) {
          url =
            '/consulting/evp-series/indicator-definitions/0/' + this.live_id;
        }

        try {
          const { data } = await axios.get(url, {
            cancelToken: this.cancelToken.token,
          });

          if (data.success) {
            this.definitions = {
              evenRows: [],
              oddRows: [],
              definitions: data.data.IndicatorDefinitionsTable.Rows,
            };

            //loop and set even and odds
            for (let i = 0; i < this.definitions.definitions.length; ++i) {
              if (i % 2 === 0) {
                this.definitions.evenRows.push(this.definitions.definitions[i]);
              } else {
                this.definitions.oddRows.push(this.definitions.definitions[i]);
              }
            }
          }
        } catch (error) {
          // TODO: HANDLE ERROR - This is just silencing the error
        }
      },
      async getCoverPage() {
        var url = '/consulting/evp-series/cover-page/' + this.report_id + '/0';
        if (this.live_id == this.report_id) {
          url = '/consulting/evp-series/cover-page/0/' + this.live_id;
        }

        try {
          const { data } = await axios.get(url, {
            cancelToken: this.cancelToken.token,
          });

          if (data.success) {
            this.cover_page = data.data;
          }
        } catch (error) {
          // TODO: HANDLE ERROR - This is just silencing the error
        }
      },
      async getMarketIndexForecastPage() {
        var url =
          '/consulting/evp-series/market-index-forecast/' +
          this.report_id +
          '/0';
        if (this.live_id == this.report_id) {
          url =
            '/consulting/evp-series/market-index-forecast/0/' + this.live_id;
        }

        try {
          const { data } = await axios.get(url, {
            cancelToken: this.cancelToken.token,
          });

          if (data.success) {
            this.forecast_market_index = data.data;
          }
        } catch (error) {
          // TODO: HANDLE ERROR - This is just silencing the error
        }
      },
      async getMarketIndexForecastHistoryPage() {
        var url =
          '/consulting/evp-series/market-index-forecast-history/' +
          this.report_id +
          '/0';
        if (this.live_id == this.report_id) {
          url =
            '/consulting/evp-series/market-index-forecast-history/0/' +
            this.live_id;
        }

        try {
          const { data } = await axios.get(url, {
            cancelToken: this.cancelToken.token,
          });

          if (data.success) {
            this.forecast_history_market_index = data.data;
          }
        } catch (error) {
          // TODO: HANDLE ERROR - This is just silencing the error
        }
      },
      async getRoCMarketIndexPage() {
        var url =
          '/consulting/evp-series/roc-market-index/' + this.report_id + '/0';
        if (this.live_id == this.report_id) {
          url = '/consulting/evp-series/roc-market-index/0/' + this.live_id;
        }

        try {
          const { data } = await axios.get(url, {
            cancelToken: this.cancelToken.token,
          });

          if (data.success) {
            this.roc_market_index = data.data;
          }
        } catch (error) {
          // TODO: HANDLE ERROR - This is just silencing the error
        }
      },
    },
  };
</script>
